import Cookies from 'js-cookie';
import CookiesStorageService from '../services/CookiesStorageService'
import OrgariseLogoBlack from '../images/OrgariseLogoBlack.png'
import OrgariseLogoWhite from '../images/OrgariseLogowhite.png'
import StaffArabiaLogo from '../images/StaffArabiaSmall.png'

export const getTenantAssets = () => {
  let displayName = 'Orgarise'
  let manifestUrl = 'manifest.json'
  let favIconUrl = './favicon/favicon.ico'
  let logoUrl = OrgariseLogoBlack
  let logoUrlWhite = OrgariseLogoWhite

  const tenantIds = CookiesStorageService.getTenantId()

  if (Cookies.get('sta_tenant_ids') || process.env.REACT_APP_STA_TENANT_IDS?.split(',')?.includes(`${tenantIds}`)) {
    displayName = 'Staff Arabia'
    manifestUrl = 'staffArabiaManifest.json'
    favIconUrl = './staffArabiaIcon/StaffArabiaTab.png'
    logoUrl = StaffArabiaLogo
    logoUrlWhite = StaffArabiaLogo
  }

  return { displayName, manifestUrl, favIconUrl, logoUrl, logoUrlWhite }
}

export default getTenantAssets
